// this is the setting for opening the right app.
//Set isTransgender to false for traditinal app.
//And set it to true for transgender settings.
const isTransgender = true;
export {isTransgender}